
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2390_23548)","fill":"#88C0B3"}},[_c('path',{attrs:{"d":"M40.562 45.629H8.128a1.31 1.31 0 00-1.308 1.305 1.31 1.31 0 001.308 1.305h32.424a1.31 1.31 0 001.308-1.305c0-.718-.579-1.305-1.298-1.305zM46.785 41.639h-10.08V8.993c0-.456-.234-.866-.617-1.109l-11.06-6.842c-.019-.01-.037-.019-.047-.028a1.144 1.144 0 00-.224-.093c-.028-.01-.047-.019-.084-.028-.084-.01-.196-.038-.327-.038-.13 0-.243.028-.336.047l-.066.019a1.047 1.047 0 00-.233.102l-11.098 6.87a1.305 1.305 0 00-.616 1.11v32.645H1.917A1.31 1.31 0 00.61 42.953a1.31 1.31 0 001.308 1.305h44.867a1.31 1.31 0 001.308-1.305c0-.718-.598-1.314-1.307-1.314zm-17.348 0h-3.783v-2.34l3.783 2.34zm4.652-2.918v2.74l-8.444-5.229v-2.74l8.444 5.229zm0-5.798v2.74l-8.444-5.23v-2.74l8.444 5.23zm0-5.799v2.741l-8.444-5.23v-2.74l8.444 5.23zm0-5.807v2.74l-8.444-5.229v-2.74l8.444 5.229zm0-5.798v2.74l-8.444-5.23v-2.74l8.444 5.23zm0-5.798v2.74l-8.444-5.23v-2.74l8.444 5.23zM23.048 4.49v37.148h-8.445V9.72l8.445-5.23z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2390_23548"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.383 .922)","d":"M0 0h52.139v53.638H0z"}})])])])
          )
        }
      }
    